"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const head_1 = __importDefault(require("next/head"));
const MetaData = ({ seoInfo }) => {
    if (!seoInfo) {
        return null;
    }
    const seoInfoKeys = seoInfo ? Object.keys(seoInfo) : [];
    if (seoInfoKeys.length === 0) {
        return null;
    }
    /* eslint-disable camelcase */
    const { 
    /* basics first level values */
    title, description, keywords, robots, canonical, } = seoInfo;
    /* modifications dates */
    const { dateModified, datePublished, dateCreated } = seoInfo;
    /* rrss_fb */
    const { rrss_fb } = seoInfo;
    const fbTitle = rrss_fb && rrss_fb['og:title'] ? rrss_fb['og:title'] : '';
    const fbType = rrss_fb && rrss_fb['og:type'] ? rrss_fb['og:type'] : '';
    const fbImage = rrss_fb && rrss_fb['og:image'] ? rrss_fb['og:image'] : '';
    const fbUrl = rrss_fb && rrss_fb['og:url'] ? rrss_fb['og:url'] : '';
    const fbDescription = rrss_fb && rrss_fb['og:description'] ? rrss_fb['og:description'] : '';
    const fbSiteName = rrss_fb && rrss_fb.site_name ? rrss_fb.site_name : '';
    /* x aki vamos */
    const { search_engines_verification } = seoInfo;
    /* microdata */
    const { microdata_product, microdata_website, breadcrums, page_name, product_name } = seoInfo;
    return (react_1.default.createElement(head_1.default, null,
        react_1.default.createElement("meta", { name: "viewport", content: "width=device-width, initial-scale=1.0, maximum-scale=5.0" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("meta", { id: "page_name", name: "page_name", content: page_name || '' }),
        react_1.default.createElement("meta", { id: "product_name", name: "product_name", content: product_name || '' }),
        react_1.default.createElement("meta", { id: "context_seo_meta", name: "description", content: description || '' }),
        keywords && react_1.default.createElement("meta", { name: "keywords", content: keywords }),
        robots && react_1.default.createElement("meta", { name: "Robots", content: robots }),
        canonical && react_1.default.createElement("link", { rel: "canonical", href: canonical }),
        react_1.default.createElement("meta", { name: "author", content: "Movistar" }),
        react_1.default.createElement("meta", { name: "owner", content: "Movistar" }),
        dateModified && react_1.default.createElement("meta", { itemProp: "dateModified", content: dateModified }),
        datePublished && (react_1.default.createElement("meta", { itemProp: "datePublished", content: datePublished })),
        dateCreated && react_1.default.createElement("meta", { itemProp: "dateCreated", content: dateCreated }),
        fbTitle && react_1.default.createElement("meta", { property: "og:title", content: fbTitle }),
        fbImage && react_1.default.createElement("meta", { property: "og:image", content: fbImage }),
        fbType && react_1.default.createElement("meta", { property: "og:type", content: fbType }),
        fbUrl && react_1.default.createElement("meta", { property: "og:url", content: fbUrl }),
        fbDescription && (react_1.default.createElement("meta", { property: "og:description", content: fbDescription })),
        fbSiteName && react_1.default.createElement("meta", { property: "og:site_name", content: "Movistar" }),
        search_engines_verification &&
            search_engines_verification.length > 0 &&
            search_engines_verification.map((item) => {
                const keyName = Object.keys(item)[0] || '';
                const value = item[keyName] || '';
                return (react_1.default.createElement("meta", { key: `${keyName}-${value}`, name: keyName, content: value }));
            }),
        microdata_product && (react_1.default.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: JSON.stringify(microdata_product) } })),
        microdata_website && (react_1.default.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: JSON.stringify(microdata_website) } })),
        breadcrums && (react_1.default.createElement("script", { type: "application/ld+json", dangerouslySetInnerHTML: { __html: JSON.stringify(breadcrums) } }))));
};
exports.default = MetaData;
//# sourceMappingURL=index.js.map